import Api from "../config/Axios";

// export const createBatch = (data) => {
//   return Api.post("api/dashboard/batch/create", data);
// };
const config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("token"),
    UserId: localStorage.getItem("user_id"),
  },
};
function objToQueryString(obj) {
  const keyValuePairs = [];
  for (const key in obj) {
    keyValuePairs.push(
      encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
    );
  }
  return keyValuePairs.join("&");
}
// Batch
export const getBatchList = (token, user_id) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/batch/default-setting", config);
};

// Batch Default Setting
export const getBatchDefaultSettingList = () => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/batch/default-setting", config);
  // return BatchD;
};

// Bulk Batch Default Configuration
export const BulkBatchDefaultConfiguration = (data) => {
  // console.log('bul default api',data)
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/batch/bulk-update-default-setting", data, config);
};

// Bulk Batch Default Configuration
export const BulkRiderBatch = (data) => {
  // console.log('bulk rider batch api',data)
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.post("api/web/rider/batch-assign/csv", data, config);
};

// Bulk Batch Default Configuration
export const BulkRiderShift = (data) => {
  // console.log('bulk rider batch api',data)
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.post("api/web/shift/assign-rider/bulk", data, config);
};

export const getShiftMongoIDs = (data) => {
  // console.log('bulk rider batch api',data)
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.post("api/web/shifts/display-ids", data, config);
};

// Wallet & Stacking List by zone
export const getWalletStackingListbyzone = (token, user_id, zid, type) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/wallet-stacking?zoneId=${zid}&type=${type}`, config);
};

// Wallet & Stacking Update
export const putWalletStackingUpdate = (token, user_id, type, zid, data) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.put(
    `api/web/wallet-stacking?zoneId=${zid}&type=${type}`,
    data,
    config
  );
};

// ************************** Change API **********************************************
// Wallet & Stacking List
export const getBatchWalletStackingList = () => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/wallet-stacking", config);
};

// Bulk Add Wallet & Stacking
export const BulkBatchWalletStacking = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.put("/api/web/wallet-stacking", data, config);
};
